import { SET_STRIPE_CONFIRM_PAYMENT_RESPONSE } from "../actions/types";
export default (state = {}, action) => {
  switch (action.type) {
    case SET_STRIPE_CONFIRM_PAYMENT_RESPONSE:
      return action.payload;
    default:
      return state;
  }
};
